// src/data/productos.js
export const productos = [
  // Hombres
  {
    id: 1,
    nombre: "Camisa Casual Hombre",
    categoria: "hombres",
    precio: 89.90,
    imagen: "https://img.freepik.com/free-photo/young-man-wearing-casual-shirt_1150-10674.jpg"
  },
  {
    id: 2,
    nombre: "Polo Deportivo Hombre",
    categoria: "hombres",
    precio: 59.90,
    imagen: "https://img.freepik.com/free-photo/young-man-wearing-sports-t-shirt_1150-10675.jpg"
  },
  {
    id: 3,
    nombre: "Zapatillas Hombre",
    categoria: "hombres",
    precio: 199.90,
    imagen: "https://img.freepik.com/free-photo/men-s-sneakers_1150-10676.jpg"
  },
  {
    id: 4,
    nombre: "Casaca Hombre",
    categoria: "hombres",
    precio: 249.90,
    imagen: "https://img.freepik.com/free-photo/men-s-jacket_1150-10677.jpg"
  },

  // Mujeres
  {
    id: 5,
    nombre: "Vestido Elegante Mujer",
    categoria: "mujeres",
    precio: 149.90,
    imagen: "https://img.freepik.com/free-photo/elegant-woman-wearing-dress_1150-10678.jpg"
  },
  {
    id: 6,
    nombre: "Blusa Casual Mujer",
    categoria: "mujeres",
    precio: 79.90,
    imagen: "https://img.freepik.com/free-photo/woman-wearing-casual-blouse_1150-10679.jpg"
  },
  {
    id: 7,
    nombre: "Falda Mujer",
    categoria: "mujeres",
    precio: 99.90,
    imagen: "https://img.freepik.com/free-photo/woman-wearing-skirt_1150-10680.jpg"
  },
  {
    id: 8,
    nombre: "Zapatillas Mujer",
    categoria: "mujeres",
    precio: 189.90,
    imagen: "https://img.freepik.com/free-photo/women-s-sneakers_1150-10681.jpg"
  },

  // Accesorios
  {
    id: 9,
    nombre: "Mochila Casual",
    categoria: "accesorios",
    precio: 119.90,
    imagen: "https://img.freepik.com/free-photo/backpack-on-table_1150-10682.jpg"
  },
  {
    id: 10,
    nombre: "Reloj Unisex",
    categoria: "accesorios",
    precio: 299.90,
    imagen: "https://img.freepik.com/free-photo/unisex-watch_1150-10683.jpg"
  },
  {
    id: 11,
    nombre: "Gorra Negra",
    categoria: "accesorios",
    precio: 49.90,
    imagen: "https://img.freepik.com/free-photo/black-cap_1150-10684.jpg"
  },
  {
    id: 12,
    nombre: "Lentes de Sol",
    categoria: "accesorios",
    precio: 129.90,
    imagen: "https://img.freepik.com/free-photo/sunglasses-on-table_1150-10685.jpg"
  },

  // Ofertas
  {
    id: 13,
    nombre: "Camisa en Oferta",
    categoria: "ofertas",
    precio: 49.90,
    imagen: "https://img.freepik.com/free-photo/sale-shirt_1150-10686.jpg"
  },
  {
    id: 14,
    nombre: "Zapatillas en Oferta",
    categoria: "ofertas",
    precio: 129.90,
    imagen: "https://img.freepik.com/free-photo/sale-shoes_1150-10687.jpg"
  },
  {
    id: 15,
    nombre: "Bolso en Oferta",
    categoria: "ofertas",
    precio: 89.90,
    imagen: "https://img.freepik.com/free-photo/sale-bag_1150-10688.jpg"
  },
  {
    id: 16,
    nombre: "Polo en Oferta",
    categoria: "ofertas",
    precio: 39.90,
    imagen: "https://img.freepik.com/free-photo/sale-t-shirt_1150-10689.jpg"
  }
];
